<script setup>
import { ref, onMounted } from 'vue';

const isVisible = ref(false);

onMounted(() => {

    setTimeout(() => {
        isVisible.value = true;
    }, 100);

});

</script>

<template>
    <div class="background-image relative min-h-screen flex items-center justify-center overflow-hidden">
        <div class="p-8 rounded-2xl bg-slate-900/80 relative z-10 max-w-2xl mx-auto text-center px-6"
            :class="{ 'opacity-0': !isVisible, 'opacity-100': isVisible }" style="transition: opacity 0.5s ease-in-out">
            <h1
                class="text-4xl font-bold mb-4 bg-gradient-to-r from-violet-600 to-violet-400 bg-clip-text text-transparent">
                We'll Be Right Back!
            </h1>
            <div class="space-y-6">
                <p class="text-lg text-slate-600 dark:text-slate-300">
                    We're making some improvements to bring you a better experience.
                </p>
                <div class="relative w-full h-px my-8 overflow-hidden">
                    <div class="absolute inset-0 bg-gradient-to-r from-transparent via-violet-500/30 to-transparent">
                    </div>
                    <div
                        class="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent animate-shimmer">
                    </div>
                </div>

                <div class="text-slate-500 dark:text-slate-400">
                    <p class="mb-4">
                        Our team is working hard to get everything back up and running.
                        We appreciate your patience.
                    </p>
                </div>
                <div class="relative w-full h-px my-8 overflow-hidden">
                    <div class="absolute inset-0 bg-gradient-to-r from-transparent via-violet-500/30 to-transparent">
                    </div>
                    <div
                        class="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent animate-shimmer">
                    </div>
                </div>
              
            </div>
        </div>
    </div>
</template>

<style scoped>
@keyframes shimmer {
    0% {
        transform: translateX(-100%);
    }

    100% {
        transform: translateX(100%);
    }
}

.animate-shimmer {
    animation: shimmer 2s infinite;
}

.background-image {
    background-image: linear-gradient(to bottom, transparent, #1e293b), url('@/assets/images/bg/bg3.webp');
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
}
</style>
